import { SecureAxios } from './Axios';
import { API_ROOT } from './Constants';
const CacheKey = 'accounts';
const BASE_PATH = `${API_ROOT}/accounts`;
const AUTH_PATH = `${API_ROOT}/auth`;
const PATHS = {
    CREATE: BASE_PATH,
    DELETE: BASE_PATH,
    GET: BASE_PATH,
    GOOGLE_LOGIN: `${AUTH_PATH}/google`,
    RESEND_EMAIL: `${BASE_PATH}/resendEmail`,
    RESET_PASSWORD: `${BASE_PATH}/resetPassword`,
    UPDATE: BASE_PATH,
    VERIFY_EMAIL: `${BASE_PATH}/verifyEmail`,
    VERIFY_PASSWORD_RESET: `${BASE_PATH}/verifyPasswordReset`,
};
async function create(csrfToken, props) {
    return (await (await SecureAxios()).post(PATHS.CREATE, { ...props }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function delete_(csrfToken) {
    return (await (await SecureAxios()).delete(PATHS.DELETE, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function get() {
    return (await (await SecureAxios()).get(PATHS.GET)).data;
}
function getKey() {
    return [CacheKey, 'get'];
}
async function resendEmail(csrfToken, email) {
    return (await (await SecureAxios()).post(PATHS.RESEND_EMAIL, { email }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function resetPassword(csrfToken, email) {
    return (await (await SecureAxios()).post(PATHS.RESET_PASSWORD, { email }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function update(csrfToken, props) {
    const form = new FormData();
    if (props.name)
        form.append('name', props.name);
    if (props.email)
        form.append('email', props.email);
    if (props.newEmail)
        form.append('newEmail', props.newEmail);
    if (props.password)
        form.append('password', props.password);
    if (props.newPassword)
        form.append('newPassword', props.newPassword);
    if (props.avatar)
        form.append('avatar', props.avatar.blob, props.avatar.filename);
    if (props.deleteAvatar !== undefined)
        form.append('deleteAvatar', String(props.deleteAvatar));
    return (await (await SecureAxios()).put(PATHS.UPDATE, form, { headers: { 'X-CSRF-Token': csrfToken, 'Content-Type': 'multipart/form-data' } })).data;
}
async function verifyEmail(csrfToken, memberId, token) {
    return (await (await SecureAxios()).post(PATHS.VERIFY_EMAIL, { memberId, token }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function verifyPasswordReset(csrfToken, memberId, token, password) {
    return (await (await SecureAxios()).post(PATHS.VERIFY_PASSWORD_RESET, { memberId, token, password }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
async function googleLogin(csrfToken, idToken) {
    return (await (await SecureAxios()).post(PATHS.GOOGLE_LOGIN, { idToken }, { headers: { 'X-CSRF-Token': csrfToken } })).data;
}
export default {
    CacheKey,
    create,
    delete_,
    get,
    getKey,
    googleLogin,
    resendEmail,
    resetPassword,
    update,
    verifyEmail,
    verifyPasswordReset,
};
